<!-- AudioSequentialPlayer.vue -->
<template>
    <span v-if="showLogo" style="float: right">
        <span @click="hideLogo">
            <AiBokeIcon/>
        </span>
    </span>
    <div v-else>
        <div style="padding: 10px;border-radius: 10px; border-top: 1px solid #eee; background: #FFF">
            <div class="lyrics-container">
                <!-- 控制按钮 -->
                <!--            <div class="lyrics-control">-->
                <!--                <a-button-->
                <!--                        type="primary"-->
                <!--                        @click="toggleLyrics"-->
                <!--                >-->
                <!--                    <template #icon>-->
                <!--                        <UpOutlined v-if="lyricsVisible"/>-->
                <!--                        <DownOutlined v-else/>-->
                <!--                    </template>-->
                <!--                    -->
                <!--&lt;!&ndash;                    {{ lyricsVisible ? '隐藏字幕' : '显示字幕' }}&ndash;&gt;-->
                <!--                </a-button>-->
                <!--            </div>-->
                <!-- 歌词弹窗 -->
                <transition name="slide-up">
                    <div v-if="lyricsVisible" class="lyrics-modal">
                        <!-- 顶部控制栏 -->
                        <div class="lyrics-header">
                            <div class="lyrics-title">
                                <sound-outlined />
                                <span>正在播放: {{ currentAudioName }}</span>
                            </div>
                            <a-button type="text" @click="closeLyrics">
                                <close-outlined />
                            </a-button>
                        </div>

                        <!-- 歌词内容区域 -->
                        <div class="lyrics-content" ref="lyricsContentRef">
                            {{lyrics}}{{data.audio_axis}}
                            <div
                                    v-for="(line, index) in lyrics"
                                    :key="index"
                                    :ref="el => lyricsRefs[index] = el"
                                    class="lyrics-line"
                                    :class="{
                                        'active': currentLyricIndex === index,
                                        'passed': index < currentLyricIndex
                                    }"
                                    @click="seekToTime(line.startTime)"
                            >
                                <div class="lyrics-text">
                                    {{index}}.                                    {{ line.text }}
                                </div>
                                <div class="lyrics-time">
                                    {{ formatTime(line.startTime) }}
                                </div>
                            </div>
                        </div>

                        <!-- 进度条 -->
                        <div class="lyrics-progress">
                            <a-progress
                                    :percent="progressPercent"
                                    :show-info="false"
                                    stroke-color="#1890ff"
                                    size="small"
                                    :gradient-colors="['#555', '#777', '#999', '#bbb', '#ddd']"
                            />
                            <div class="time-display">
                                <span>{{ formatTime(currentTime) }}</span>
                                <span>{{ formatTime(duration) }}</span>
                            </div>
                        </div>
                    </div>
                </transition>

                <!-- 音频播放器 -->
                <audio
                        ref="audioRef"
                        @timeupdate="handleTimeUpdate"
                        @loadedmetadata="handleLoadedMetadata"
                        @ended="handleAudioEnd"
                ></audio>
            </div>
            <a-row>
                <a-col span="12">
                    <a-space>
                        <div style="margin-top: 8px" @click="handleHide">
                            <AiBokeIcon :isPlaying="isPlaying"/>
                        </div>
                        <div @click="toggleLyrics" style="margin-top: 7px">Voice paper</div>
                    </a-space>
                </a-col>
                <a-col span="12" style="text-align: right;">
                    <a-space>
                        <span class="paper-help-color">
                            <a-space>
                                {{ currentTimeFormatted }} | <LoadingComponent v-if="loading"/><span v-else>{{durationFormatted}}</span>
                            </a-space>
                        </span>
                        <CircleProgress
                                type="circle"
                                :progress="progress"
                                :show-info="false"
                                :size="40"
                                :stoke-width="1"
                                :status="loading? 'active': ''"
                        >
                            <template #format>
                                <a
                                        @click="togglePlay"
                                        :loading="loading"
                                        class="paper-primary-text"
                                        style="margin-top: 5px"
                                >
                                    <PauseCircleFilled v-if="isPlaying" style="font-size: 24px"/>
                                    <PlayCircleFilled v-else style="font-size: 24px"/>
                                </a>
                            </template>
                        </CircleProgress>
                    </a-space>
                </a-col>




                <!--                    {{ lyricsVisible ? '隐藏字幕' : '显示字幕' }}-->
            </a-row>
            <!--        <audio v-if="data.audio_url" style="width: 100%; background: #FFF" controls :src="data.audio_url"/>-->
            <div class="audio-info1" style="margin-top: 16px; display: none">
                <a-progress
                        :percent="progress"
                        :show-info="false"
                        size="small"
                        :status="loading? 'active': ''"
                />
                <div style="margin-top: 8px; text-align: right" class="paper-help-color">
                    <a-space>
                        {{ currentTimeFormatted }} |
                        <LoadingComponent v-if="loading"/><span v-else>{{durationFormatted}}</span>
                    </a-space>
                </div>
            </div>
        </div>
    </div>
</template>

<script setup>
    import { ref, computed, onUnmounted, defineProps,  defineEmits, nextTick, watch} from 'vue'
    import {
        PlayCircleFilled, PauseCircleFilled,
    } from '@ant-design/icons-vue';
    import AiBokeIcon from './AiBokeIcon';
    import CircleProgress from './CircleProgress';
    import LoadingComponent from './LoadingComponent';
    import {post_audio_next} from "../utils/bioinfo.api";
    import {get_args, isDEV} from "../utils/request";

    const props = defineProps({
        title: {
            type: String,
            default: '',
        },
        paper: {
            type: Object,
            required: true,
            default: () => {}
        },
        data: {
            type: Object,
            required: true,
            default: () => {}
        },
        autoPlayNext: {
            type: Boolean,
            default: true
        },
        playBoke: {
            type: Boolean,
            default: false
        }
    });

    const emit = defineEmits(['play', 'pause', 'stop', 'end'])

    const showLogo = ref(false);
    const audioPlayer = ref(null);
    const finalUrl = ref(props.data?.audio_url);
    const isPlaying = ref(props.playBoke);
    const loading = ref(false);
    const currentTime = ref(0);
    const duration = ref(0);
    const durationSum = ref(0);
    const currentAudio = ref(props.data?.audio_url);
    const currentIndex = ref(props.data?.audio_index);
    const currentStatus = ref(props.data?.status);
    const lyrics = ref(props.data?.audio_axis);
    const isFinal = ref(props.data?.status === 1);
    const progress = ref(0);
    const currentInfo = ref({});

    // 计算属性
    const isInfoEnded = computed(() => {
        return props.data.status === 1 && currentAudio.value === finalUrl.value;
    });

    // 计算属性
    // const currentAudio = computed(() => {
    //     return props.data?.audio_url || null
    // })

    // // 计算属性
    // const currentIndex = computed(() => {
    //     return props.data?.audio_index || 0
    // })
    //
    // // 计算属性
    // const currentStatus = computed(() => {
    //     return props.data?.status
    // });

    // const progress = computed(() => {
    //     if (duration.value === 0) return 0;
    //     if(currentStatus.value < 0) return 0;
    //     if(currentStatus.value === 0) return 0.01;
    //     return Math.round((currentTime.value / duration.value) * 100)
    // });
    watch(()=>props.playBoke, (newVal, oldVal) => {
        console.log(`playBokesdf 从 ${oldVal} 变为 ${newVal}`);
        if(newVal){
            if(!isPlaying.value){
                play();
            }
        }
    });
    const currentTimeFormatted = computed(() => {
        return formatTime(currentTime.value)
    });

    const durationFormatted = computed(() => {
        if(currentStatus.value === 1) return formatTime(duration.value);
        return '--:--'
    });
    const timer = ref(null);
    // 初始化播放器
    const initPlayer = () => {

        audioPlayer.value = new Audio();

        // 添加事件监听


        // audioPlayer.value.addEventListener('timeupdate', () => {
        //     if(!isFinal.value) currentTime.value += audioPlayer.value.currentTime;
        //     console.log('currentTime.value', currentTime.value);
        //     if(props.data.status === 1){
        //         console.log('duration.value', duration.value);
        //         progress.value = Math.round((currentTime.value / duration.value) * 100);
        //     }
        //
        // });

        audioPlayer.value.addEventListener('loadedmetadata', () => {
            // 不对
            // 判断是详情页已经结束的
            if(isInfoEnded.value) duration.value = audioPlayer.value.duration;
            else durationSum.value += audioPlayer.value.duration;
            console.log('duration.value', duration.value);
            //如果是完整的话Math.round((currentTime.value / duration.value) * 100)

            if(!timer.value) timer.value = setInterval(()=>{
                if(isPlaying.value) {
                    currentTime.value += 1;
                    if(currentStatus.value === 0) {
                        if(progress.value < 100) progress.value += 0.05;
                    }
                    if(currentStatus.value < 0 ) progress.value = 0;
                    if(isInfoEnded.value){
                        let p = (currentTime.value / duration.value) * 100;
                        if(progress.value < 100 && p < 100) {
                            if(isFinal.value) progress.value = Math.round(p);
                        }
                    }
                }

            }, 1000);


        });


        audioPlayer.value.addEventListener('ended', () => {
            console.log('第', currentIndex.value , '段结束了');
            postPlayNext();
            emit('end', currentIndex.value)
        });
        audioPlayer.value.addEventListener('error', (error) => {
            console.error('播放错误:', error);
            loading.value = false
        })
    };
    const hideLogo = ()=>showLogo.value = false;
    const handleHide = ()=>{
        showLogo.value = true;
    };
    // 切换播放状态
    const togglePlay = async () => {
        // if (!currentAudio.value) return
        if (isPlaying.value) {
            pause()
        } else {
            await play()
        }
    };

    // 播放
    const play = async () => {
        if(progress.value >= 100 && currentStatus.value === 1) stop();
        if(currentAudio.value) await handleAudioPlay();
        else await postPlayNext();
        // else if (currentStatus.value === 1) await handleAudioPlay();
    };

    // 播放
    const handleAudioPlay = async () => {
        if(!currentAudio.value) {
            return ;
        }
        if (!audioPlayer.value) {
            initPlayer();
        }
        if (audioPlayer.value.src !== currentAudio.value) {
            audioPlayer.value.src = currentAudio.value;
            await audioPlayer.value.load()
        }

        try {
            console.log('play...');
            loading.value = !isInfoEnded.value;
            await audioPlayer.value.play();
            isPlaying.value = true;
            emit('play', currentIndex.value)
        } catch (error) {
            console.error('播放失败:', error)
        }
    };

    // 暂停
    const pause = () => {
        if (audioPlayer.value) {
            audioPlayer.value.pause();
            isPlaying.value = false;
            emit('pause', currentIndex.value)
        }
    };

    // 停止
    const stop = () => {
        if (audioPlayer.value) {
            audioPlayer.value.pause()
            audioPlayer.value.currentTime = 0
            isPlaying.value = false
            currentTime.value = 0;
            progress.value = 0;
            emit('stop', currentIndex.value)
        }
    };


    // 播放下一首
    const postPlayNext = async () => {
        if (!isFinal.value) {
            // stop()
            let {paper_no, upload_no} = get_args();
            paper_no = Number(paper_no);
            upload_no = Number(upload_no);
            post_audio_next({paper_no, upload_no, last_index: currentIndex.value}, async (res)=>{
                if(res?.data){
                    let {
                        audio_url, status, exist, final_audio_url, index
                    } = res.data;
                    loading.value = true;
                    if(final_audio_url) finalUrl.value = final_audio_url;
                    if(index) currentIndex.value = index;
                    let notExist = (typeof exist === 'boolean') && (!exist);
                    currentStatus.value = status;
                    isFinal.value = status === 1 && notExist;
                    currentInfo.value = {...res.data};
                    if(audio_url) {
                        currentAudio.value = audio_url;
                        await handleAudioPlay();
                    }
                    else if(status === 0 && notExist){
                        setTimeout(()=>{
                            postPlayNext();
                        }, 1000);
                    }else if(isFinal.value) {
                        handleEnded();
                        duration.value = currentTime.value;
                        console.log('durationSum.value', durationSum.value);
                        console.log('duration.value', duration.value);
                    }
                    console.log('isFinal', isFinal.value);
                    // audioPlayer.value.src = audio_url;
                    // await audioPlayer.value.load();

                }
            });
        }
        else handleEnded();
    };
    const handleEnded = async ()=>{
        console.log('最后一段播放结束了');
        loading.value = false;
        progress.value = 100;
        isPlaying.value = false;
        if(timer.value) clearInterval(timer.value);
        if(finalUrl.value){
            currentAudio.value = finalUrl.value;
            // audioPlayer.value.src = finalUrl.value;
            // await audioPlayer.value.load();
        }
    };
    // // 播放上一首
    // const playPrevious = () => {
    //     if (currentIndex.value > 0) {
    //         currentIndex.value--
    //         stop()
    //         play()
    //     }
    // }

    // 切换音频
    // const changeAudio = (index) => {
    //     currentIndex.value = index
    //     stop()
    //     play()
    // }

    // 格式化时间
    const formatTime = (seconds) => {
        if (isNaN(seconds)) return '00:00'

        const mins = Math.floor(seconds / 60)
        const secs = Math.floor(seconds % 60)
        return `${mins.toString().padStart(2, '0')}:${secs.toString().padStart(2, '0')}`
    };
    // 音频和歌词数据
    const audioRef = ref(null);
    const lyricsContentRef = ref(null);
    const lyricsRefs = ref([]);

    // 状态管理
    const lyricsVisible = ref(false);
    const currentLyricIndex = ref(-1);
    // 切换歌词显示
    const toggleLyrics = () => {
        if(isDEV){
            lyricsVisible.value = !lyricsVisible.value;
            if (lyricsVisible.value) {
                // 歌词显示后，确保滚动到正确位置
                setTimeout(scrollToCurrentLyric, 100)
            }
        }
    };
    const closeLyrics = () => {
        lyricsVisible.value = false
    };
    // 滚动到当前歌词
    const scrollToCurrentLyric = () => {
        if (currentLyricIndex.value >= 0 && lyricsRefs.value[currentLyricIndex.value]) {
            nextTick(() => {
                const activeElement = lyricsRefs.value[currentLyricIndex.value]
                if (activeElement && lyricsContentRef.value) {
                    // 计算滚动位置（使当前歌词在中间）
                    const container = lyricsContentRef.value
                    const elementTop = activeElement.offsetTop
                    const elementHeight = activeElement.offsetHeight
                    const containerHeight = container.clientHeight

                    container.scrollTo({
                        top: elementTop - containerHeight / 2 + elementHeight / 2,
                        behavior: 'smooth'
                    })
                }
            })
        }
    };

    // 跳转到指定时间
    const seekToTime = (time) => {
        if (audioRef.value) {
            audioRef.value.currentTime = time
            if (!isPlaying.value) {
                audioRef.value.play()
                isPlaying.value = true
            }
        }
    };
    // 清理资源
    onUnmounted(() => {
        console.log('boke onUnmounted');
        // if (audioPlayer.value) {
        //     audioPlayer.value.pause();
        //     audioPlayer.value = null
        // }
    })
</script>

<style scoped>
    .audio-logo{
        border-radius: 30px;
        border: 1px solid #ccc;
        padding: 14px 7px 6px;
    }
    .audio-player {
        padding: 16px;
        border: 1px solid #d9d9d9;
        border-radius: 4px;
    }

    .audio-info {
        background: #fafafa;
        padding: 12px;
        border-radius: 4px;
    }
    .audio-icon {
        font-size: 24px!important;
        transition: all 0.3s;
    }


    .lyrics-container {
        position: relative;
        font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
    }

    .lyrics-control {
        position: fixed;
        bottom: 20px;
        right: 20px;
        z-index: 1000;
    }

    /* 歌词弹窗样式 */
    .lyrics-modal {
        position: fixed;
        bottom: 0;
        left: 0;
        right: 0;
        height: 400px;
        background: linear-gradient(to top, rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.35));
        backdrop-filter: blur(10px);
        color: white;
        z-index: 999;
        border-top: 1px solid rgba(255, 255, 255, 0.1);
        box-shadow: 0 -5px 20px rgba(0, 0, 0, 0.3);
        display: flex;
        flex-direction: column;
    }

    .lyrics-header {
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 16px 20px;
        border-bottom: 1px solid rgba(255, 255, 255, 0.1);
    }

    .lyrics-title {
        display: flex;
        align-items: center;
        gap: 10px;
        font-size: 16px;
        font-weight: 500;
    }

    .lyrics-content {
        flex: 1;
        overflow-y: auto;
        padding: 20px;
        scroll-behavior: smooth;
    }

    .lyrics-line {
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 12px 16px;
        margin: 8px 0;
        border-radius: 8px;
        cursor: pointer;
        transition: all 0.3s ease;
        opacity: 0.6;
    }

    .lyrics-line:hover {
        background: rgba(255, 255, 255, 0.05);
        opacity: 0.8;
    }

    .lyrics-line.active {
        opacity: 1;
        background: rgba(24, 144, 255, 0.2);
        transform: scale(1.02);
    }

    .lyrics-line.active .lyrics-text {
        font-size: 20px;
        font-weight: 600;
        color: #1890ff;
        text-shadow: 0 0 10px rgba(24, 144, 255, 0.5);
    }

    .lyrics-line.passed {
        opacity: 0.8;
        color: #aaa;
    }

    .lyrics-text {
        font-size: 16px;
        line-height: 1.5;
        transition: all 0.3s ease;
        flex: 1;
    }

    .lyrics-time {
        font-size: 12px;
        color: rgba(255, 255, 255, 0.5);
        margin-left: 20px;
        min-width: 50px;
    }

    .lyrics-progress {
        padding: 12px 20px;
        border-top: 1px solid rgba(255, 255, 255, 0.1);
    }

    .time-display {
        display: flex;
        justify-content: space-between;
        margin-top: 8px;
        font-size: 12px;
        color: rgba(255, 255, 255, 0.7);
    }

    /* 动画效果 */
    .slide-up-enter-active,
    .slide-up-leave-active {
        transition: transform 0.3s cubic-bezier(0.34, 1.56, 0.64, 1);
    }

    .slide-up-enter-from,
    .slide-up-leave-to {
        transform: translateY(100%);
    }

    .slide-up-enter-to,
    .slide-up-leave-from {
        transform: translateY(0);
    }

    /* 自定义滚动条 */
    .lyrics-content::-webkit-scrollbar {
        width: 6px;
    }

    .lyrics-content::-webkit-scrollbar-track {
        background: rgba(255, 255, 255, 0.05);
        border-radius: 3px;
    }

    .lyrics-content::-webkit-scrollbar-thumb {
        background: rgba(255, 255, 255, 0.2);
        border-radius: 3px;
    }

    .lyrics-content::-webkit-scrollbar-thumb:hover {
        background: rgba(255, 255, 255, 0.3);
    }
</style>